/**
 * 画面コンポーネント
 * エラー表示画面
 */
import React, { useContext } from "react";

import LanguageContext from "../contexts/Language";
import StatusContext from "../contexts/Status";

/**
 * 汎用エラー画面表示
 * @param title タイトル部分に表示する文字列、もしくはリソースＩＤ（未指定でタイトル非表示）
 * @param error エラー内容部分に表示する文字列、もしくはリソースＩＤ（未指定で空欄表示）
 * @param redirect_to 下部のボタンの遷移先（未指定でボタン非表示）。action指定が未指定の場合のみ有効
 * @param to_button 下部のボタンのラベル（未指定で"戻る"を表示）
 * @param action 下部のボタンの処理内容。選択式（"close":タグごと閉じる、未指定でリダイレクト処理）
 * @param btn_action 下部のボタン押下時の動作。指定した場合、"redirect_to"および"action"の値は無視され、指定した関数が実行される
 * @returns 
 */
export default function Error(props) {
  const { getTag } = useContext(LanguageContext);
  const { setPageStatus } = useContext(StatusContext);

  console.dir(props);
  /**
   * 直接呼出し/history経由対応のマッピング変換
   */
  var params;
  if (props.location) {
    params = props.location.state;
  }
  else {
    params = props;
  }
  var title = params.title;
  var error = params.error;
  var redirect_to = params.redirect_to;
  var to_button = params.to_button;
  var action = params.action;
  var btn_action = params.btn_action;

  /**
   * クリックイベント
   */
  const handleClick = () => {
    if (btn_action) {
      btn_action();
    } else {
      setPageStatus(redirect_to);
    }
  };

  let useTitle = null;
  if (title) {
    useTitle = (title === getTag(title)) ? title : getTag(title);
  }

  let useError = "";
  if (error) {
    useError = (error === getTag(error)) ? error : getTag(error);
  }

  let useBtnLabel = getTag('common.return');
  if (to_button) {
    useBtnLabel = (to_button === getTag(to_button)) ? to_button : getTag(to_button);
  }

  let useAction = null;
  if (action === "close") {
    useAction = window.close;
  }
  else if (redirect_to || btn_action) {
    useAction = handleClick;
  }

  return (
    <div>
      <div className="form">
        {useTitle && <h1 className="title">{useTitle}</h1>}
        <p className="description">{useError}</p>
        <div className="spacer"> </div>
        <div className="action_area">
          {useAction && <p className="action_btn"><button className="btn_l acceptbtn" onClick={useAction}>{useBtnLabel}</button></p>}
        </div>
      </div>
    </div>
  );
}
